<template>
  <BaseCard v-if="displayConfirmationMessage">
    <BaseCardBody>
      <div class="flex flex-col space-y-2">
        <BaseButton danger small :disabled="pending" @click="deleteMedium"> Confirm </BaseButton>
        <BaseButton ghost small :disabled="pending" @click="displayConfirmationMessage = false">
          Cancel
        </BaseButton>
      </div>
    </BaseCardBody>
  </BaseCard>
  <BaseCard v-else>
    <BaseCardBody>
      <span class="inline-block mb-2 text-xs text-gray-600">{{ humanReadableCreatedAt }}</span>
      <a :href="url" target="_blank" class="block">
        {{ name }}
      </a>
    </BaseCardBody>
    <BaseCardFooter gray>
      <div class="flex justify-between">
        <BaseBadge custom class="bg-indigo-300 text-indigo-900">
          {{ fileType }}
        </BaseBadge>
        <BaseButton danger small @click="confirmDelete"> Delete </BaseButton>
      </div>
    </BaseCardFooter>
  </BaseCard>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    mimeType: {
      type: String,
      default: null,
    },
    contactRequestId: {
      type: String,
      required: true,
    },
    createdAt: {
      type: String,
      default: '',
    },
    editable: Boolean,
  },
  data() {
    return {
      displayConfirmationMessage: false,
      pending: false,
    };
  },
  computed: {
    humanReadableCreatedAt() {
      if (!this.createdAt) {
        return null;
      }

      return moment(this.createdAt).fromNow();
    },
    isImage() {
      return this.mimeType.includes('image/');
    },
    isPDF() {
      return this.mimeType === 'application/pdf';
    },
    isVideo() {
      return this.mimeType.includes('video/');
    },
    fileType() {
      if (this.isImage) {
        return 'image';
      }

      if (this.isPDF) {
        return 'pdf';
      }

      if (this.isVideo) {
        return 'video';
      }

      return this.mimeType;
    },
  },
  methods: {
    confirmDelete() {
      this.displayConfirmationMessage = true;
      setTimeout(() => {
        if (this.pending) {
          return;
        }
        this.displayConfirmationMessage = false;
      }, 3000);
    },
    async deleteMedium() {
      try {
        this.pending = true;
        await this.$store.dispatch({
          type: 'ui/contactRequestAttachments/destroy',
          id: this.contactRequestId,
          attachmentId: this.id,
        });
      } catch (error) {
        //
      } finally {
        this.pending = false;
      }
    },
  },
};
</script>
